import { FormStore } from '@roc/feature-app-core';

const trackRecordOtherForm = {
  fields: {
    generalContractor: {
      value: null,
      error: null,
      message: '',
      rule: '',
    },
    broker: {
      value: null,
      error: null,
      message: '',
      rule: '',
    },
    previousExperience: {
      value: 'Yes',
      error: null,
      message: '',
      rule: 'required',
    },
    numberOfVerifiedInvestmentProperties: {
      value: '',
      error: null,
      rule: '',
      message: 'Number of verified Investment Properties is Required.',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class TrackRecordOtherFormStore extends FormStore {

  constructor(globalStore) {
    super({ ...trackRecordOtherForm }, globalStore);
  }

}